// A handful of zones (6 of ~32,800) arrive from Hotelbeds with a placeholder name — literally
// "." or "…." — in every language. They aren't broken rows and they aren't a sync bug (they do
// have description records); the source simply never gave them a real name. Rendered verbatim
// they look like empty rows, which is what the client flagged.
//
// So the table shows a clear, derived fallback instead — "Zone {code}" — with the real city and
// country still in their own columns, so the row is identifiable and editable. isBlankZoneName
// also lets the UI mark these visually and lets an admin find them.

// True when a name is missing, whitespace-only, or made up entirely of dots/punctuation noise
// (".", "….", "-", …) — i.e. carries no real information.
export const isBlankZoneName = (name) => {
  const s = String(name ?? "").trim();
  return s === "" || /^[.…\s\-_/\\]+$/.test(s);
};

// What to show in the Zone Name column. Falls back to "Zone {code}" for a blank/placeholder
// name; otherwise the trimmed real name.
export const zoneDisplayName = (zone) => {
  if (!zone) return "";
  if (!isBlankZoneName(zone.name)) return String(zone.name).trim();
  const code = zone.zoneCode ?? zone.code;
  return code != null && String(code).trim() !== "" ? `Zone ${String(code).trim()}` : "Unnamed zone";
};
